import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setLoading, setSuccess } from '../../../actions/loadingActions';
import { IHistory, ISelectOptions } from '../../../interfaces';
import { loginDataFetch, submitSignUpForm, getCompaniesByEmail, submitForgotPassword, loginUsingAAD, verifyOtpDataFetch, resendOtpDataFetch } from '../../../services/loginService';
import { resetMfa } from '../../../actions/loginActions';
import { dispatch, isFormEmpty, showAlert } from '../../../utils/generalUtils';
import { Alert } from '../../Alert';
import { Async } from '../../reusableComponents/Async';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CircularProgress from 'material-ui/CircularProgress';
import './loginForm.scss';
import { RRFInput } from '../../reusableComponents/FormComponents/RRFInput';
import { actions, Form } from 'react-redux-form';
import PropTypes from 'prop-types';
import { Loader } from '../../reusableComponents/Loader'; 
import { EMPTY_FORM_MESSAGE } from '../../../constants/general'; 
import { AlertModal } from '../../reusableComponents/ModalComponents/AlertModal'; 
import { SubmissionLoader } from '../../reusableComponents/SubmissionLoader'; 
import logoURL from'../../../images/SafeLogo.png';  
import AzureAuthenticationContext from "./auth/azure-authentication-context";
import { AccountInfo } from "@azure/msal-browser";
import { AADPWD } from '../../../constants/general';

export interface ILoginFormImplProps {
    history: IHistory;
    isLoggedIn: boolean;
    alertType: string;
    pathName: string;
    company?: string;
    isMfaRequired?: boolean;
    mfaData?: any;
}

export interface ILoginFormImplState {
    isSignUpPage: boolean;
    errorMessage: string;
    email: string;
    company: string;
    isValidUser: boolean;
    menuItems: ISelectOptions[];
    forgotPasswordClicked: boolean;
    isL1User: boolean;
    otp: string;
    timer: number;
    resendCooldown: number;
    isMfaRequired?: boolean;
    mfaData?: any;
}

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const isIE = msie > 0 || msie11 > 0;
//const authenticationModule: AzureAuthenticationContext = new AzureAuthenticationContext();

export class LoginFormImpl extends React.PureComponent<ILoginFormImplProps, ILoginFormImplState> {

    loginIdentifier: string = 'login';
    signUpIdentifier: string = 'sing-up';
    timerInterval: any = null;

    constructor(props: ILoginFormImplProps | Readonly<ILoginFormImplProps>) {
        super(props);
        this.state = {
            email: '', company: '', isValidUser: false, errorMessage: '', isSignUpPage: false,
            forgotPasswordClicked: false, isL1User: false, menuItems: [], otp: '',
            timer: 300, resendCooldown: 30, isMfaRequired: false, mfaData: null
        };
    }

    componentDidMount() {
        if (this.props.isMfaRequired) {
            this.startTimer();
        }
    }

    componentDidUpdate(prevProps: ILoginFormImplProps) {
        if (!prevProps.isMfaRequired && this.props.isMfaRequired) {
            this.startTimer();
        } else if (prevProps.isMfaRequired && !this.props.isMfaRequired) {
            this.clearTimer();
        }
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    startTimer = (resetExpiry: boolean = true) => {
        this.clearTimer();
        if (resetExpiry) {
            this.setState({ timer: 300, resendCooldown: 30 });
        } else {
            this.setState({ resendCooldown: 30 });
        }
        this.timerInterval = setInterval(() => {
            this.setState((prevState) => {
                const newTimer = prevState.timer > 0 ? prevState.timer - 1 : 0;
                const newCooldown = prevState.resendCooldown > 0 ? prevState.resendCooldown - 1 : 0;
                return {
                    timer: newTimer,
                    resendCooldown: newCooldown
                };
            });
        }, 1000);
    };

    clearTimer = () => {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
    };

    formatTime = (seconds: number) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins < 10 ? '0' : ''}${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    promise = async () => {
        return null;
    }

    /**
     * To set the initial state of the loader in the login button.
     */
    componentWillMount() {
        setSuccess(this.loginIdentifier);
        setSuccess(this.signUpIdentifier);
        if (!this.props.isLoggedIn) {
            dispatch(actions.reset('forms.loginForm'));
            return;
        }
        this.props.history.push('/home');
    }

    getChildContext() {
        if (this.state.isSignUpPage) {
            return { formModel: 'forms.signUpForm' };
        }
        return { formModel: 'forms.loginForm' };
    }

    static childContextTypes = {
        formModel: PropTypes.string
    };

    getCompanies = async () => {
        try {
            const companyNames = await getCompaniesByEmail(this.state.email);
            this.setState({
                menuItems: companyNames
            });
            /* this.setState({
                isValidUser: true
            }); */
            setSuccess('login'); 
            let isL1User = this.state.email.toLowerCase().indexOf('spius.net') > -1;
            if(this.state.menuItems.length===1) {
                dispatch(actions.change(`forms.loginForm.company`, this.state.menuItems[0].label)); 
                this.setState({ company: this.state.menuItems[0].value || '' });
            } else {
                if(!isL1User || (isL1User && this.state.menuItems.length===1) ) {
                    dispatch(actions.change(`forms.loginForm.company`, this.state.menuItems[0].label)); 
                    this.setState({ company: this.state.menuItems[0].value || '' });
                } 
            }
        } catch (error) {
            setSuccess('login');
            showAlert('Not a valid user', 'login', 'danger');
            throw error;
        }
    }

    handleEmailChange = (e: { target: { value: any; }; }) => {
        this.setState({
            email: e.target.value
        });
        /* this.setState({ isL1User: false, isValidUser: false }); */
    } 
    handleCompanyChange = (e: any) => { 
        this.setState({ company: e });
    } 
    /**
     * Submits the form to the sever. Collects the data from the username field and password field.
     */
    handleLogin = async ({ username, password, company }: any) => {
        setLoading(this.loginIdentifier); 
        let esubmittedValues: any; 
        if(this.state.isValidUser) {
            esubmittedValues = { username, password, company }; 
        } else {
            esubmittedValues = { username }; 
        } 
        if (isFormEmpty(esubmittedValues)) {
            setSuccess('login');
            showAlert(EMPTY_FORM_MESSAGE, 'login', 'danger');
            return;
        } 
        if (isFormEmpty(esubmittedValues)) {
            setSuccess('login');
            showAlert(EMPTY_FORM_MESSAGE, 'login', 'danger');
            return;
        } 
        /* if (!this.state.isValidUser) {
            this.getCompanies();
            return;
        } */

        if (!this.state.isL1User && username.toLowerCase().indexOf('spius.net') > -1) { 
            await this.getCompanies();
            await this.setState({ isL1User: true, isValidUser: true });
            return;
        } else if(!this.state.isValidUser) {
            await this.getCompanies();
            await this.setState({ isValidUser: true });
            return;
        }
        const { props: { history, pathName } } = this;
        // username = '12'; // password='pass'; 
        const loginRes: any = await loginDataFetch(username, password, company, history, pathName);
        if (loginRes && loginRes.requireMFA) {
            this.setState({ isMfaRequired: true, mfaData: loginRes });
            this.startTimer();
        }
    } 
    forgotPassword = async () => { 
        const requestData = {
            email: this.state.email, 
            company: this.state.company 
        };
        const esubmittedValues = { email:requestData.email }
        if (isFormEmpty(esubmittedValues)) {
            showAlert('Please fill username', 'login', 'danger');
            return;
        } 
        const csubmittedValues = { company: requestData.company }
        if (isFormEmpty(csubmittedValues)) {
            showAlert('Please select company', 'login', 'danger');
            return;
        } 
        const { props: { history } } = this;
        this.setState({ forgotPasswordClicked: true });
        await submitForgotPassword(requestData, history); 
        this.setState({ forgotPasswordClicked: false });
    }
    renderLoginForm = () => {
        const { props: { alertType }, handleLogin } = this;
        return (
            <Form model="forms.loginForm" className="login" onSubmit={handleLogin}> 
                <div className="title">
                    <img src={logoURL} style={{ width: '45%', height: '100%' }} alt="SafeConnect" />
                </div>
                <Alert className={`${alertType}-alert`} id="login" />
                <AlertModal id="login-form-modal" />
                <div className="input-field">
                    <InputField className="username" placeholder="Username" onChange={this.handleEmailChange} type="text" model=".username"
                    />
                    {this.state.isValidUser &&
                        <React.Fragment>
                            <InputField className="password" placeholder="Password" type="password" model=".password" />
                            
                        </React.Fragment>
                    }
                    {this.state.isL1User && 
                        <RRFInput
                            className="password"
                            placeholder="Select company..."
                            type="dropdown"
                            menuItems={this.state.menuItems}
                            model=".company"
                            onSelect={this.handleCompanyChange}
                        /> 
                    }
                </div>
                <Async
                    promise={this.promise}
                    loader={<span className="button-loading">
                        <MuiThemeProvider>
                            <CircularProgress color="#FFFFFF" size={30} />
                        </MuiThemeProvider>
                    </span>}
                    identifier={this.loginIdentifier}
                    content={<button style={
                        !this.state.isValidUser ? {
                            width: '150px',
                            height: '40px',
                        } : {}
                    } className="button">{this.state.isValidUser ? 'Login' : 'Next'}</button>}
                />
                { /*<div className="sign-up-option" >
                    Don't have an account? <br />
                    <span onClick={this.handleFormChange} className="sign-up-text"> SignUp for Demo</span>
                 </div> */
                }
                { this.state.isValidUser && !this.state.forgotPasswordClicked && <div className="sign-up-option forgot-password " onClick={this.forgotPassword}>
                        Forgot password?
                    </div> 
                }
                { this.state.forgotPasswordClicked && <SubmissionLoader /> }

                { this.props.company && this.props.company.toLocaleLowerCase()==='spi' && <div style={{marginTop: '20px', textAlign: 'center'}}> <div style={{color: '#fff', marginBottom:'10px', fontSize: '12px', display: 'none'}}>(Or) Social Authentications:</div>
                    <button type="button" className="sso" onClick={() => this.AADLogIn("loginPopup")}>Single Sign On (SSO) {/* <img src={adLogo} className="App-loago" alt="logo" /> */} </button> 
                </div> }
                
            </Form>
        );
    }
    AADLogIn(type: any) {
        if(!this.props.company) {
            return;
        }
        let clientId = AADPWD[this.props.company.toLowerCase()];
        if(!clientId) {
            showAlert('Invalid login', 'login', 'danger');
            return;
        }
        const typeName = "loginPopup";
        const logInType = isIE ? "loginRedirect" : typeName; 
        // Azure Login
        
        const authenticationModule: AzureAuthenticationContext = new AzureAuthenticationContext(clientId);
        authenticationModule.login(logInType, this.returnedAccountInfo);
    }
    returnedAccountInfo  = async (user: AccountInfo) => { 
        if(user && this.props.company) {
            this.setState({forgotPasswordClicked: true});
            await loginUsingAAD(user, this.props.company); 
        }
    }
    
    handleFormChange = () => {
        this.setState({ isSignUpPage: !this.state.isSignUpPage });
    } 
    handleSignUp = (submittedValues: { userId: any; password: any; firstName: any; lastName: any; email: any; jobDesc: any; jobTitle: any; }) => {
        setLoading(this.signUpIdentifier);
        const valuesToValidate = {
            userId: submittedValues.userId,
            password: submittedValues.password,
            firstName: submittedValues.firstName,
            lastName: submittedValues.lastName,
            email: submittedValues.email,
            jobDesc: submittedValues.jobDesc,
            jobTitle: submittedValues.jobTitle,
        };
        if (isFormEmpty(valuesToValidate)) {
            setSuccess(this.signUpIdentifier);
            showAlert(EMPTY_FORM_MESSAGE, 'sign-up', 'danger');
            return;
        }
        return submitSignUpForm(submittedValues, this.props.history);
    } 
    renderSignUpForm = () => {
        return (
            <Form model="forms.signUpForm" className="sign-up" onSubmit={this.handleSignUp}>
                <div className="title">
                    <img src={logoURL} style={{ width: '45%', height: '100%' }} alt="SafeConnect"/>
                </div>
                <Alert className={`${this.props.alertType}-alert`} id="sign-up" />
                <div className="input-field">
                    <InputField className="username" placeholder="User Id (Numbers only)" type="number" model=".userId" />
                    <InputField className="password" placeholder="Password" type="password" model=".password" />
                    <InputField className="username" placeholder="First Name" type="text" model=".firstName" />
                    <InputField className="username" placeholder="Last Name" type="text" model=".lastName" />
                    <InputField className="username" placeholder="Email" type="email" model=".email" />
                    <InputField className="username" placeholder="Phone Number" type="number" model=".phoneNumber" />
                    <InputField className="username" placeholder="Job Description" type="text" model=".jobDesc" />
                    <InputField className="username" placeholder="Job Title" type="text" model=".jobTitle" />
                    <InputField className="username" placeholder="Company Name" type="text" model=".originalCompany" />
                </div>
                <Async
                    promise={this.promise}
                    loader={<span className="button-loading">
                        <MuiThemeProvider>
                            <CircularProgress color="#FFFFFF" size={30} />
                        </MuiThemeProvider>
                    </span>}
                    identifier={this.signUpIdentifier}
                    content={<button className="button">Sign Up</button>}
                />
                <div className="sign-up-option" >
                    Continue to
                    <span onClick={this.handleFormChange} className="sign-up-text"> Login</span>
                </div>
            </Form>
        );
    } 
    handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value.replace(/[^0-9]/g, '');
        if (val.length <= 6) {
            this.setState({ otp: val });
        }
    };

    handleVerifyOtp = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!this.state.otp || this.state.otp.length !== 6) {
            showAlert('Please enter a valid 6-digit OTP', 'login', 'danger');
            return;
        }
        let mfaData = this.state.mfaData;
        if (!mfaData && this.props.mfaData) {
            mfaData = typeof this.props.mfaData.toJS === 'function' ? this.props.mfaData.toJS() : this.props.mfaData;
        }
        mfaData = mfaData || {};
        await verifyOtpDataFetch(this.state.otp, mfaData);
    };

    handleResendOtp = async () => {
        if (this.state.resendCooldown > 0) return;
        let mfaData = this.state.mfaData;
        if (!mfaData && this.props.mfaData) {
            mfaData = typeof this.props.mfaData.toJS === 'function' ? this.props.mfaData.toJS() : this.props.mfaData;
        }
        mfaData = mfaData || {};
        const resendRes: any = await resendOtpDataFetch(mfaData);
        if (resendRes && resendRes.otp_token) {
            this.setState({
                otp: '',
                mfaData: {
                    ...mfaData,
                    otp_token: resendRes.otp_token
                }
            });
        }
        this.startTimer(true);
    };

    handleBackToLogin = () => {
        this.clearTimer();
        resetMfa();
        this.setState({ otp: '', timer: 300, resendCooldown: 30, isMfaRequired: false, mfaData: null });
    };

    renderOtpForm = () => {
        const { props: { alertType }, handleVerifyOtp } = this;
        let mfaData = this.state.mfaData;
        if (!mfaData && this.props.mfaData) {
            mfaData = typeof this.props.mfaData.toJS === 'function' ? this.props.mfaData.toJS() : this.props.mfaData;
        }
        mfaData = mfaData || {};
        const userName = mfaData.name && mfaData.name !== 'User' ? mfaData.name : '';
        const userEmail = mfaData.email || '';
        const isTimerExpired = this.state.timer === 0;

        return (
            <form className="login" onSubmit={handleVerifyOtp} style={{
                width: '430px',
                maxWidth: '92vw',
                padding: '28px 24px 24px 24px',
                borderRadius: '40px',
                boxShadow: '0 20px 45px rgba(0, 15, 35, 0.65)',
                border: '1px solid rgba(255, 255, 255, 0.12)'
            }}>
                {/* SafeConnect Logo */}
                <div className="title" style={{ padding: '0 0 8px 0' }}>
                    <img src={logoURL} style={{ width: '48%', height: 'auto', maxHeight: '55px', objectFit: 'contain' }} alt="SafeConnect" />
                </div>

                {/* Header Badge & Title */}
                <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        background: 'rgba(75, 119, 190, 0.22)',
                        border: '1px solid rgba(75, 119, 190, 0.5)',
                        color: '#B2C6E4',
                        padding: '4px 14px',
                        borderRadius: '20px',
                        fontSize: '11px',
                        fontWeight: 600,
                        letterSpacing: '0.8px',
                        textTransform: 'uppercase',
                        marginBottom: '8px'
                    }}>
                        <span>🔐 Two-Factor Authentication</span>
                    </div>
                    <h3 style={{ color: '#FFFFFF', fontSize: '20px', fontWeight: 700, margin: '2px 0 0 0' }}>
                        Security Verification
                    </h3>
                </div>

                {/* User Identity Info Card */}
                <div style={{
                    background: 'rgba(255, 255, 255, 0.06)',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    borderRadius: '16px',
                    padding: '12px 16px',
                    margin: '0 auto 16px auto',
                    textAlign: 'center',
                    maxWidth: '350px'
                }}>
                    <p style={{ color: '#B9B9B9', fontSize: '13px', margin: '0 0 6px 0' }}>
                        A 6-digit verification code was sent to:
                    </p>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        color: '#66afe9',
                        fontWeight: 600,
                        fontSize: '14px',
                        wordBreak: 'break-all'
                    }}>
                        <span>✉️</span>
                        <span>{userEmail}</span>
                    </div>
                </div>

                <Alert className={`${alertType}-alert`} id="login" />

                {/* OTP Input Field */}
                <div className="input-field" style={{ textAlign: 'center', marginTop: '12px' }}>
                    <input
                        className="username"
                        type="text"
                        placeholder="• • • • • •"
                        value={this.state.otp}
                        onChange={this.handleOtpChange}
                        maxLength={6}
                        autoFocus
                        disabled={isTimerExpired}
                        style={{
                            width: '270px',
                            height: '52px',
                            textAlign: 'center',
                            letterSpacing: '12px',
                            fontSize: '24px',
                            fontWeight: 700,
                            borderRadius: '18px',
                            background: '#FFFFFF',
                            color: '#003152',
                            border: isTimerExpired ? '2px solid #F44336' : '2px solid #4b77be',
                            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.25)',
                            paddingLeft: '14px'
                        }}
                    />
                </div>

                {/* Countdown Timer Display */}
                <div style={{ textAlign: 'center', marginTop: '12px', marginBottom: '6px' }}>
                    {!isTimerExpired ? (
                        <span style={{
                            color: this.state.timer <= 60 ? '#FFA726' : '#88CEB2',
                            fontSize: '13px',
                            fontWeight: 600,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}>
                            <span>⏱️ Code expires in:</span>
                            <span style={{ fontFamily: 'monospace', fontSize: '15px', fontWeight: 700 }}>
                                {this.formatTime(this.state.timer)}
                            </span>
                        </span>
                    ) : (
                        <span style={{ color: '#F44336', fontSize: '13px', fontWeight: 600 }}>
                            ⚠️ Code has expired. Please request a new code.
                        </span>
                    )}
                </div>

                {/* Verify Button */}
                <Async
                    promise={this.promise}
                    loader={
                        <span className="button-loading" style={{ width: '75%', borderRadius: '50px' }}>
                            <MuiThemeProvider>
                                <CircularProgress color="#FFFFFF" size={30} />
                            </MuiThemeProvider>
                        </span>
                    }
                    identifier={this.loginIdentifier}
                    content={
                        <button
                            type="submit"
                            className="button"
                            disabled={isTimerExpired || this.state.otp.length !== 6}
                            style={{
                                width: '75%',
                                height: '48px',
                                fontSize: '18px',
                                marginTop: '16px',
                                opacity: (isTimerExpired || this.state.otp.length !== 6) ? 0.6 : 1,
                                cursor: (isTimerExpired || this.state.otp.length !== 6) ? 'not-allowed' : 'pointer',
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Verify & Proceed
                        </button>
                    }
                />

                {/* Bottom Navigation & Resend Timer */}
                <div className="sign-up-option" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '20px 18px 4px 18px',
                    fontSize: '13px'
                }}>
                    <span
                        onClick={this.handleBackToLogin}
                        className="sign-up-text"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
                    >
                        ← Back to Login
                    </span>

                    {this.state.resendCooldown > 0 ? (
                        <span style={{ color: '#888888', cursor: 'not-allowed', fontSize: '12px' }}>
                            Resend code in {this.state.resendCooldown}s
                        </span>
                    ) : (
                        <span
                            onClick={this.handleResendOtp}
                            className="sign-up-text"
                            style={{ cursor: 'pointer', fontWeight: 600 }}
                        >
                            Resend Code ↻
                        </span>
                    )}
                </div>
            </form>
        );
    };

    renderContent = () => {
        const isMfa = this.state.isMfaRequired || this.props.isMfaRequired;
        return (
            <div className={`login-form ${this.state.isSignUpPage ? 'sign-up-form' : ''}`}>
                {
                    this.state.isSignUpPage ?
                        this.renderSignUpForm() :
                        (isMfa ? this.renderOtpForm() : this.renderLoginForm())
                }
            </div>
        );
    } 
    render() { 
        return <div>
            <Async
                identifier="LoginForm"
                promise={this.promise}
                error={<div></div>}
                loader={<Loader size={50} />}
                content={this.renderContent()}
            />
        </div>;
    }
}

/**
 * To be used for fetching the login state of the user.
 * @param login A Map of the immutable Object.
 */
export function mapStateToProps(state: any, ownProps: any) {
    let pathName = '/home';
    if (ownProps.location.search) {
        pathName = ownProps.location.search.split('=')[1];
    }
    const company = ownProps.match.params.company;
    return {
        isLoggedIn: state.login.get('isLoggedIn'),
        alertType: state.alert.get('type'),
        isMfaRequired: state.login.get('isMfaRequired'),
        mfaData: state.login.get('mfaData'),
        pathName, company, 
    };
}
export const LoginForm = withRouter(connect(mapStateToProps)(LoginFormImpl)); 
export const error: React.CSSProperties = {
    position: 'relative',
    top: '39%',
    width: '100%',
    textAlign: 'center',
    color: 'red'
}; 
const InputField = ({ className, placeholder, type, model, ...props }: any) => {
    return <RRFInput
        className={className}
        placeholder={placeholder}
        onChange={props.onChange}
        type={type}
        model={model}
    />;
};
